export default __webpack_public_path__ + "static/og_image-d281287cb5672f779fbee41f4ef443b6.jpg";